// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"267":"2c0835fe1e646cc4044a","926":"90c63f89bf5aaf79313b"}[chunkId] + ".chunk.js";
};